import { useEffect, useState } from 'react'

import Analytics from 'utils/googleAnalytics'

import { useAdFree, useAdFreeTrialStatus } from 'hooks/adFree'
import { useRandomCanryTrial } from 'hooks/useCanary'

import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'
import Image from 'components/elements/Image'
import Modal from 'components/elements/Modal'
import FreeTrialDetails from 'components/accountSettingsPage/details/FreeTrialDetails'

import styles from './inhouseFixedAd.module.scss'

const sevenDays = new Date(Date.now() + 1000 * 60 * 60 * 24 * 7)
const sixtyDays = new Date(Date.now() + 1000 * 60 * 60 * 24 * 60)

const InhouseFixedAd = () => {
  const [adFreeTrialModal, setAdFreeTrialModal] = useState(false)

  const [adFreeStatus] = useAdFreeTrialStatus()
  const [showAdFreeButton, handleRejectOffer] = useRandomCanryTrial('ad-free-button', 0.01, sevenDays)

  const adFree = useAdFree()

  useEffect(() => {
    if (!adFree && showAdFreeButton) Analytics.signalEvent('Free-trial rendered')
  }, [adFree, showAdFreeButton])

  if (adFree) return null

  return (
    <>
      {showAdFreeButton && adFreeStatus === 'NOT_STARTED' && (
        <div className={styles.patreonInfo}>
          <button onClick={() => setAdFreeTrialModal(true)}>
            <Image src="/images/logo.svg" alt="Archidekt" height={25} width={25} className={styles.logo} /> Click to try
            Archidekt without ads for <span className={styles.free}>FREE</span>
          </button>
        </div>
      )}

      <div className={styles.desktopAdheasion} id="fixed-ad" data-ad-slot="anchor">
        <Link href="https://www.patreon.com/archidekt/membership" className={styles.patreonLink} target="_blank">
          <Icon name="patreon" /> Support us on Patreon to remove ads
        </Link>
      </div>

      <Modal
        open={adFreeTrialModal}
        onOpen={() => Analytics.signalEvent('Free-trial opened')}
        onClose={() => setAdFreeTrialModal(false)}
        closeButton>
        <FreeTrialDetails
          onCancel={() => {
            handleRejectOffer(sixtyDays)
            setAdFreeTrialModal(false)

            Analytics.signalEvent('Free-trial rejected')
          }}
        />
      </Modal>
    </>
  )
}

export default InhouseFixedAd
